module.exports = __webpack_public_path__ + "static/media/p3.1ea430bb.jpeg";